// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".featured-quote-clamp[data-v-12e3b2f8]{-webkit-box-orient:vertical;-webkit-line-clamp:4;display:-webkit-box;max-height:8rem;overflow:hidden}.quote-viewport[data-v-12e3b2f8]{touch-action:pan-y pinch-zoom}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
